import React from 'react';
import { motion } from 'framer-motion';
const tools = [{
  name: 'ChatGPT',
  svg: <svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-332">
        <path d="M29.71 13.09A8 8 0 0 0 21 3.06 8 8 0 0 0 7.06 6.94 8 8 0 0 0 3.06 19a8 8 0 0 0 8.94 13a8 8 0 0 0 14-3.06 8 8 0 0 0 4-13ZM17.5 28a5.94 5.94 0 0 1-3.85-1.4l.19-.11 6.4-3.7a1 1 0 0 0 .53-.91v-9l2.7 1.56v7.47A6 6 0 0 1 17.5 28ZM4.6 22.5a6 6 0 0 1-.71-4l.19.11 6.4 3.7a1 1 0 0 0 1.05 0l7.82-4.51v3.11l-6.48 3.74a6 6 0 0 1-8.27-2.17ZM2.92 12.6a6 6 0 0 1 3.13-2.63v7.61a1 1 0 0 0 .52.91l7.79 4.49-2.7 1.56-6.47-3.74a6 6 0 0 1-2.27-8.2Zm22.2 5.17-7.82-4.54L20 11.67l6.47 3.74a6 6 0 0 1-.92 10.81v-7.61a1 1 0 0 0-.43-.84ZM27.81 11.63l-.19-.11-6.4-3.7a1 1 0 0 0-1.05 0l-7.82 4.5V9.21l6.48-3.73a6 6 0 0 1 8.95 6.21ZM10.13 19.27l-2.71-1.56v-7.47a6 6 0 0 1 9.84-4.61l-.19.11-6.4 3.7a1 1 0 0 0-.53.91Zm1.47-3.18 3.48-2 3.48 2v4l-3.48 2-3.48-2Z" data-id="element-333" />
      </svg>
}, {
  name: 'Claude',
  svg: <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-334">
        <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" data-id="element-335" />
        <path d="M19 4L19.6 6.4L22 7L19.6 7.6L19 10L18.4 7.6L16 7L18.4 6.4L19 4Z" data-id="element-336" />
        <path d="M5 14L5.5 16L7.5 16.5L5.5 17L5 19L4.5 17L2.5 16.5L4.5 16L5 14Z" data-id="element-337" />
      </svg>
}, {
  name: 'Gemini',
  svg: <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-338">
        <path d="M12 0C12 6.627 6.627 12 0 12C6.627 12 12 17.373 12 24C12 17.373 17.373 12 24 12C17.373 12 12 6.627 12 0Z" data-id="element-339" />
      </svg>
}, {
  name: 'Perplexity',
  svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-340">
        <circle cx="12" cy="12" r="10" data-id="element-341" />
        <line x1="12" y1="2" x2="12" y2="22" data-id="element-342" />
        <path d="M2 12h20" data-id="element-343" />
        <path d="M12 7l5 5-5 5" data-id="element-344" />
      </svg>
}, {
  name: 'Notion',
  svg: <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-345">
        <path d="M4 4h12l4 4v12H4V4zm2 2v12h12V9h-3V6H6zm10 0v2h2l-2-2zM7 10h10v1.5H7zm0 3h10v1.5H7zm0 3h7v1.5H7z" data-id="element-346" />
      </svg>
}, {
  name: 'Copilot',
  svg: <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" data-id="element-347">
        <ellipse cx="8" cy="12" rx="4" ry="5" data-id="element-348" />
        <ellipse cx="16" cy="12" rx="4" ry="5" data-id="element-349" />
      </svg>
}];
export function WorksWith() {
  return <section className="py-16 bg-black-charcoal border-y border-white/5 relative" data-id="element-350">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-351">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-xs font-bold tracking-[0.25em] uppercase text-muted mb-10" data-id="element-352">
          Works seamlessly with every major AI tool
        </motion.p>

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8 md:gap-x-14" data-id="element-353">
          {tools.map((tool, i) => <motion.div key={tool.name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08,
          duration: 0.5
        }} className="flex items-center gap-2.5 text-offwhite/70 hover:text-offwhite transition-colors cursor-default" data-id="element-354">
              {tool.svg}
              <span className="font-display font-bold text-xl tracking-tight" data-id="element-355">
                {tool.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}